import { parse } from 'graphql';

// Codegen emits types from the matching source operations. These parsed documents
// are the Field Ops operations sent by the authenticated dashboard client.
const CORE_CONFIGURATION_FIELDS = `
  tokenValid
  envTokenInUse
  webhooks {
    trigger
    expectedTarget
    configured
    coreStatus
    consecutiveFailures
    totalSuccessfulRequests
    totalFailedRequests
  }
`;

export const CORE_CONFIGURATION_DOCUMENT = parse(/* GraphQL */ `
  query CoreConfiguration {
    coreConfiguration {
      ${CORE_CONFIGURATION_FIELDS}
    }
  }
`);

export const PROVISION_CORE_API_TOKEN_DOCUMENT = parse(/* GraphQL */ `
  mutation ProvisionCoreApiToken {
    provisionCoreApiToken {
      ${CORE_CONFIGURATION_FIELDS}
    }
  }
`);

export const PROVISION_CORE_WEBHOOKS_DOCUMENT = parse(/* GraphQL */ `
  mutation ProvisionCoreWebhooks {
    provisionCoreWebhooks {
      ${CORE_CONFIGURATION_FIELDS}
    }
  }
`);

export const REACTIVATE_CORE_WEBHOOKS_DOCUMENT = parse(/* GraphQL */ `
  mutation ReactivateCoreWebhooks {
    reactivateCoreWebhooks {
      ${CORE_CONFIGURATION_FIELDS}
    }
  }
`);
